import { render, staticRenderFns } from "./view_shipping.vue?vue&type=template&id=ad4a3330&lang=html"
import script from "./view_shipping.vue?vue&type=script&lang=js"
export * from "./view_shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports